import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./plan.css";
import useFormValidation from "../../hooks/useFormValidator";
import { signUp } from "../../axios/signUp.axios";
import { useSelector, useDispatch } from "react-redux";
import { setTempUser } from "../../actions/signUp.actions";
import { NotificationContainer } from "react-notifications";
import { Link } from "react-router-dom";
import { products } from "../../products/products.details";

const OrderCheckoutSignUp = (props) => {
  // const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const code = useSelector((state) => state.changeStep.affiliate);
  const product = useSelector((state) => state.product.details);
  console.log(product,"product in sign up")
  const [input, setInput] = useState({
    email: "",
    password: "",
    affiliate: "",
    package_name: "",
    isOrderCheckoutUser: true,
    user_type:"",
    isVipEscapeBuckUser: false,
    isEscapeBuckPlan: false
  });

  const [validationReport, validate] = useFormValidation();

  const change = async (wizard) => {
    if (
      validationReport.email &&
      validationReport.email.isValid &&
      validationReport.password &&
      validationReport.password.isValid &&
      validationReport.package_name
    ) {
      props.loader(true);
      await signUp(input)
        .then((response) => {
          // console.log(response,"res")
          dispatch(setTempUser(response.data.data));
          props.changeWizard(wizard);
          props.loader(false);
        })
        .catch((err) => {
          //    alert(err.response.data.message)
          props.notify(err.response.data.message, false);
          props.loader(false);
        });
    } else {
    }
  };

  const handleChange = (event) => {
    console.log(event.target.value,"event")
    let rules = JSON.parse(event.target.dataset.rules);

    validate(event.target.value, rules, event.target.name);
    if (event.target.name === "email") {
      setInput({
        ...input,
        [event.target.name]: event.target.value.toLowerCase(),
      });
    } else if(event.target.name === "package_name") {
      setInput({ ...input, package_name: event.target.value,user_type: event.target.selectedOptions[0]?.dataset?.type});
    
    } else {
      setInput({ ...input, [event.target.name]: event.target.value });
    }
  };

  function log() {
    console.log("report", validationReport);
  }

  useEffect(() => {
    if (code)
      setInput({
        affiliate: code,
      });
  }, code);

  useEffect(() => {
    if(product){
      setInput({
        ...input,
        isVipEscapeBuckUser: product.isVip,
        isEscapeBuckPlan: product.isEscapeBuckPlan
      });
    }
  },[product])

  return (
    <div className="sign_up_partts">
      <NotificationContainer />
      <h3>1. Sign Up</h3>
      <p>
        To purchase this plan and use its benefits in the future, log in to your
        account or sign up.
      </p>

      <Form>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            value={input.email}
            type="email"
            name="email"
            placeholder="Enter email address"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              email: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.email && !validationReport.email.isValid ? (
            <small className="text-danger">
              {validationReport.email.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
          {log()}
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            value={input.password}
            name="password"
            type="password"
            placeholder="Password"
            className="sign_email"
            data-rules={JSON.stringify({
              required: true,
              password: true,
            })}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          {validationReport.password && !validationReport.password.isValid ? (
            <small className="text-danger">
              {validationReport.password.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Choose Product</Form.Label>
          <Form.Select
            name="package_name"
            className="form-control"
            data-rules={JSON.stringify({
              required: true,
              package: true,
            })}
            required
            onChange={(event) => {
              handleChange(event);
              if (event.target.value) {
                console.log(event.target.value,"event.target.value")
                props.setProduct(event);
              }
            }}
          >
            <option value="">Select Product</option>

            {products.tvi && products.tvi.length > 0 && products.tvi.map((prod) => {
              return (
                prod.isEscapeBuckPlan && (
                 <option
                    data-price={prod.price}
                    data-product_id={prod.id}
                    data-name={prod.name}
                    data-type={"individual"}
                    data-product-type={prod.isEscapeBuckPlan}
                    value={prod.id}
                  >
                    {prod.name}
                  </option>
                  )
              )
            })}
            {/* {products.tvi && products.tvi.length > 0 && products.tvi.map((prod) => {
              return (
                prod.isEscapeBuckPlan ? (
                 <option
                    data-price={prod.price}
                    data-product_id={prod.id}
                    data-name={prod.name}
                    data-type={"individual"}
                    data-product-type={prod.isEscapeBuckPlan}
                    value={prod.id}
                  >
                    {prod.name}
                  </option>
                  ):(
                    <option
                        data-price={prod.price}
                        data-product_id={prod.id}
                        data-name={prod.name}
                        data-type={prod.plan_type}
                        value={prod.id}
                        data-product-type={prod.isEscapeBuckPlan}
                      >
                        TVI 12 Month Membership $947
                      </option>
                  )
              )
            })} */}
          </Form.Select>
          {validationReport.package && !validationReport.package.isValid ? (
            <small className="text-danger">
              {validationReport.package.errorMessage}{" "}
            </small>
          ) : (
            ""
          )}
        </Form.Group>

        <div className="sign_submit flex-wrap justify-content-between align-items-center">
          <p className="mb-0">
            Already have an account? <Link to="/login">Login</Link>
          </p>
          {/* {show && <AdditionalInfo />} */}
          <Button
            variant="primary"
            type="button"
            onClick={() => {
              if(product.isEscapeBuckPlan){
                if(product.coupon){

                  change("aInfo");
                }else{
                  props.notify("Please enter a valid coupon", false);
                }
              }else{
                 change("aInfo");
              }
              
              // change("aInfo");
            }}
          >
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default OrderCheckoutSignUp;
